<template lang="pug">
.page-meta
    el-row.no-margin(:gutter="40")
        el-col(:md="12")
            el-form-item(:label="$t('Title')")
                el-input(
                    v-model="title"
                    maxlength="255"
                    :placeholder="titlePlaceholder"
                    :show-word-limit="true"
                )
            el-form-item.no-margin(:label="$t('Keywords')")
                el-select.is-full-width(
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    placeholder=""
                    v-model="keywords"
                )
                    el-option(
                        v-for="tag in keywords"
                        :key="tag"
                        :value="tag"
                    )
        el-col(:md="12")
            el-form-item.no-margin(:label="$t('Description')")
                el-input(
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 40 }"
                    v-model="description"
                )
</template>

<i18n>
{
    "de": {
        "Title": "Titel",
        "Description": "Beschreibung",
        "Keywords": "Keywords"
    }
}
</i18n>

<script>

// import Vue from 'vue'

import _ from 'lodash'
import { useSetupStore, usePageStore } from '@/stores'

export default {
    name: 'Main',
    props: {
        titlePlaceholder: {
            type: String,
            required: false
        },
    },
    computed: {
        pageStore() {
            return usePageStore()
        },
        form() {
            return this.pageStore.form
        },
        map() {
            const metas = _.get(this.form, 'metas') || []
            let map = {}
            metas.forEach((el, i) => map[el.key] = i)
            return map
        },
        title: {
            get() {
                return _.get(this.form, `metas.${this.map.title}.value`) || ''
            },
            set(value) {
                const meta = { value, key: 'title' }
                this.pageStore.setFormMeta(meta)
            }
        },
        description: {
            get() {
                return _.get(this.form, `metas.${this.map.description}.value`) || ''
            },
            set(value) {
                const meta = { value, key: 'description' }
                this.pageStore.setFormMeta(meta)
            }
        },
        keywords: {
            get() {
                const keywords = _.get(this.form, `metas.${this.map.keywords}.value`) || ''
                return keywords.split(',').filter(Boolean)
            },
            set(value) {
                const meta = { value: value.join(','), key: 'keywords' }
                this.pageStore.setFormMeta(meta)
            }
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
    },
}
</script>

<style lang="sass" scoped>
// .page-meta
//     ::v-deep
//         textarea
//             min-height: 80px !important
</style>
